<template>
  <StdPageContainer type="list">
    <template slot="title">
      <!-- 标题栏 -->
      <StdPageTitle title="回收站"></StdPageTitle>
    </template>
    <!-- 内容区 -->
    <template slot="content">
      <section class="null-data" v-if="list && list.length == 0 && !isSearch">
        <StdNullPage text="暂无数据" :nullType="'nullData'"></StdNullPage>
      </section>
      <template v-else-if="list">
        <StdSearchBar
          v-model="searchForm.name"
          placeholder="请输入名称"
          @search="handleCurrentChange(1)"
        ></StdSearchBar>
        <vh-table :data="list" class="trash-list">
          <vh-table-column label="名称">
            <template slot-scope="scope">
              <vh-tooltip
                placement="top"
                :disabled="!isTextOverflow"
                :content="scope.row.resource_name"
              >
                <div class="videoName custom-tooltip-content">
                  <i
                    class="iconfont-v3 saasshipinwenjian media-icon"
                    v-if="scope.row.resource_type == 1"
                  ></i>
                  {{ scope.row.resource_name || '- -' }}
                </div>
              </vh-tooltip>
            </template>
          </vh-table-column>
          <vh-table-column label="删除时间">
            <template slot-scope="scope">
              <span>{{ scope.row.delete_time }}</span>
            </template>
          </vh-table-column>
          <vh-table-column label="暂存至">
            <template slot-scope="scope">
              <span>{{ scope.row.expire_time }}</span>
            </template>
          </vh-table-column>
          <vh-table-column label="来源" width="100">
            <template slot-scope="scope">
              <span>音视频</span>
            </template>
          </vh-table-column>
          <vh-table-column label="操作" width="100">
            <template slot-scope="scope">
              <vh-button type="text" @click="handleRestore(scope.row)">恢复</vh-button>
            </template>
          </vh-table-column>
          <template slot="empty">
            <StdNullPage :nullType="'search'"></StdNullPage>
          </template>
        </vh-table>
        <StdPagination
          :total="total || 0"
          :page-size="searchForm.limit"
          :currentPage="searchForm.pageNo"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </template>
  </StdPageContainer>
</template>
<script>
  import {
    StdPageContainer,
    StdPageTitle,
    StdNullPage,
    StdPagination,
    StdSearchBar
  } from '@vhcl/ui-console';
  import tableCellTooltip from '@/components/TableList/mixins/tableCellTooltip';
  export default {
    name: 'Trash',
    mixins: [tableCellTooltip],
    components: {
      StdPageContainer,
      StdPageTitle,
      StdNullPage,
      StdSearchBar
    },
    data() {
      return {
        list: '',
        total: 0,
        searchForm: {
          name: '',
          limit: 10,
          pageNo: 1
        },
        isSearch: false
      };
    },
    created() {
      this.handleCurrentChange(1);
      this.toast = this.$vhMessage({
        message: '删除后30天内可进行恢复，超过30天系统自动删除',
        type: 'warning',
        duration: 0,
        showClose: true
      });
    },
    beforeDestroy() {
      this.toast.close();
    },
    methods: {
      handleCurrentChange(page) {
        this.searchForm.pageNo = page;
        this.getTableList();
      },
      handleSizeChange(limit) {
        this.searchForm.limit = limit;
        this.searchForm.pageNo = 1;
        this.getTableList();
      },
      getTableList() {
        const params = {
          limit: this.searchForm.limit,
          pos: (this.searchForm.pageNo - 1) * this.searchForm.limit,
          resource_type: 1, // 1:音视频
          resource_name: this.searchForm.name
        };
        this.isSearch = params.resource_name ? true : false;
        this.$fetch('gitTrashList', params).then(res => {
          if (res.code == 200) {
            this.list = res.data.list;
            this.total = res.data.total;
          }
        });
      },
      handleRestore(row) {
        this.$confirm('当前内容将恢复至原来位置，确认要恢复？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          roundButton: true
        }).then(() => {
          this.$fetch('recoverTrash', { id: row.id }).then(res => {
            if (res.code == 200) {
              this.$vhMessage.success('恢复成功');
              this.getTableList();
            } else {
              this.$vhMessage.error(res.msg);
            }
          });
        });
      }
    }
  };
</script>
<style lang="less" scoped>
  .null-data {
    min-height: calc(100vh - 240px);
    position: relative;
    background: #fff;
  }
  .trash-list {
    .media-icon {
      color: #ff733c;
    }
  }
</style>
